import { Bank } from "../../types/aso.ebi";
import { generateAPI } from "../api.generator";

export const getAllBanks = generateAPI<{}, Bank[]>("get", "aso-ebi/banks/all");
